<!-- Loading State -->
@if (service.rubricLoading) {
  <div class="rubric-loading">
    <lucide-icon [img]="icons.Loader2" class="rubric-loading-spinner"></lucide-icon>
    <p class="rubric-loading-text">Loading scoring guide...</p>
  </div>
}

<!-- Content (after loading) -->
@if (!service.rubricLoading) {
  <!-- Rubric Display -->
  @if (service.rubric) {
    <div class="rubric-display">
      <app-scoring-guide-table
        [item]="service.rubric"
        [standards]="service.rubricStandards"
      ></app-scoring-guide-table>
    </div>
  }

  <!-- Empty State -->
  @if (!service.rubric && service.rubricLoaded) {
    <div class="rubric-empty">
      <lucide-icon
        [img]="icons.ClipboardList"
        class="rubric-empty-icon"
      ></lucide-icon>
      <p class="rubric-empty-title">No scoring guide yet</p>
      <p class="rubric-empty-desc">
        A scoring guide will be automatically generated when you save this
        question.
      </p>
    </div>
  }
}
